import { getBasePath } from "./getBasePath";
import { escapeRegExp } from "lodash";
export interface ImagesFactory {
  get(name: string): string;
}

export function imagesFactory(
  appId: string,
  isBuildPush?: boolean,
  version?: string
): ImagesFactory {
  return {
    get(name) {
      const getSuffix = (): string => {
        let suffix = window.APP_ROOT
          ? `${window.APP_ROOT}${
              window.BOOTSTRAP_UNION_FILE && window.PUBLIC_DEPS ? "" : "-/"
            }`
          : "";
        if (!suffix.startsWith("/")) {
          suffix = getBasePath() + suffix;
        }
        if (window.APP_ID && window.APP_ID !== appId) {
          return suffix
            .replace(
              new RegExp(`(^|/)${escapeRegExp(window.APP_ID)}/`),
              `$1${appId}/`
            )
            .replace(/\/\d+\.\d+\.\d+\//, `/${version}/`);
        }
        return suffix;
      };
      return isBuildPush
        ? `${getBasePath()}api/gateway/object_store.object_store.GetObject/api/v1/objectStore/bucket/next-builder/object/${name}`
        : window.BOOTSTRAP_UNION_FILE && window.PUBLIC_DEPS
        ? `${getSuffix()}images/${name}`
        : `${getSuffix()}micro-apps/${appId}/images/${name}`;
    },
  };
}

export function widgetImagesFactory(
  widgetId: string,
  widgetVersion?: string
): ImagesFactory {
  return {
    get(name) {
      return `${window.PUBLIC_ROOT ?? ""}bricks/${widgetId}/${
        window.PUBLIC_ROOT_WITH_VERSION && widgetVersion
          ? `${widgetVersion}/`
          : ""
      }dist/assets/${name}`;
    },
  };
}
